import { Metadata } from '../../../../utils/spds/metadata';
import Super from './column.gjs';

const METADATA = Metadata.define({
  description: `
Flex reverse column layout component

A convenience wrapper around \`Spds::Core::Container\` that renders a reversed flexbox column. It sets both
\`@column={{true}}\` and \`@reverse={{true}}\` on the underlying container, so items flow from bottom to top. Useful for
patterns such as chat interfaces or timelines, where the most recent items should appear first.
  `,
  name: 'Flex Reverse Column',
});

export default class SpdsLayoutFlexReverseColumn extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  reverse = true;
  variantClass = 'spds-layout-flex-reverse-column';
}

export const LAYOUT_FLEX_REVERSE_COLUMN_METADATA = SpdsLayoutFlexReverseColumn.metadata;
